<template>
    <div class="mb-3">
        <div class="mt-4">Eine der beiden Optionen auswählen</div>
        <input type="file" ref="videoUpload" accept="video/mp4, video/quicktime, audio/mpeg, audio/mp3" hidden />
        <div :class="{
                'grid grid-cols-2': !extraVideoFile && !extraSoundFile
            }">
            <div class="mt-2 mr-1" v-if="!extraSoundFile && !extraVideoFile">
                <Recorder
                    :before-recording="beforeRecording"
                    :after-recording="afterRecording"
                    :show-time="true" class="h-full"
                    :grid-layout="true"
                    :btn-line-height="true"
                    :time="180"
                    :mic-failed="micFailed"
                    @click="addQrCode">
                    <template slot="StartBtnLabel">Audiobotschaft aufnehmen
                        <div class="sublabel">max. 3 Minuten</div></template>
                </Recorder>
            </div>
            <div class="mt-2" v-if="extraSoundFile">
                <!-- Single soundFile: refactor to own component -->
                <div class="recording-box cursor-pointer my-2 flex" @click="togglePlayback()">
                    <div class="recording-box__inner flex">
                        <Player :record="extraSoundFile" ref="player"/>
                        <div class="flex-grow ml-2">
                            Zusatz <span v-if="extraSoundFile.duration">({{ extraSoundFile.duration }} sek)</span>
                        </div>
                    </div>
                    <span @click="removeExtraRecord" class="icon-trash"></span>
                </div>
            </div>
            <div class="mt-2 ml-1" v-if="!extraVideoFile && !extraSoundFile && !isRecording">
                <button class="btn line-height-normal w-full" type="button" :disabled="uploading" @click="uploadVideo">Videobotschaft aufnehmen
                    <div class="sublabel">max. 50 MB</div></button>
            </div>
            <div class="mt-2" v-if="extraVideoFile">
                <button class="btn" type="button" @click="removeExtraRecord">Video entfernen</button>
            </div>
        </div>
        <div class="mt-2 text-orange" v-if="fileSizeTooBig">Deine hochgeladene Datei ist zu groß, bitte lade eine Datei mit maximal 50MB Größe hoch!</div>
        <div class="mt-2 text-orange" v-if="invalidFile">Deine Datei konnte nicht hochgeladen werden, bitte lade ein gültiges Video im MP4-Format, MOV-Format oder eine Sounddatei im MP3-Format hoch!</div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Popover from '~/scripts/Components/Popover.vue';
import Player from "../1_SoundConfiguration/Player.vue";
import Checkbox from "~/scripts/Components/Checkbox.vue";
import Recorder from "../1_SoundConfiguration/Recorder.vue";
import Pipeline from '../../../Pipeline/Pipeline';

export default {
    components: {
        Player,
        Popover,
        Checkbox,
        Recorder
    },
    computed: {
        ...mapFields({
            isRecording: 'isRecording',
            isCountdown: 'isCountdown',
            initUserMedia: 'initUserMedia',
            addExtraSound: 'extraSound.use',
            extraSoundFile: 'extraSound.soundFile',
            extraVideoFile: 'extraSound.videoFile'
        })
    },
    data() {
        return {
            fileSizeTooBig: false,
            invalidFile: false,
            uploading: false
        };
    },
    mounted() {
        const self = this;

        this.$refs.videoUpload.addEventListener('change', async function() {
            let uploadedFile = this.files && this.files[0] ? this.files[0] : null;
            self.uploading = true;
            self.invalidFile = false;
            self.fileSizeTooBig = false;

            if (!uploadedFile) {
                self.invalidFile = true;
                self.uploading = false;
                return;
            }

            if (uploadedFile.type != 'audio/mpeg' &&
            uploadedFile.type != 'audio/mp3' &&
            uploadedFile.type != 'video/mp4' &&
            uploadedFile.type != 'video/quicktime') {
                self.invalidFile = true;
                self.uploading = false;
                return;
            }

            // interrupt if filesize is bigger than 10MB
            if ((uploadedFile.size / (1024*1024)) > 50) {
                self.fileSizeTooBig = true;
                self.uploading = false;
                return;
            }

            // add to store
            if (uploadedFile.type == 'video/mp4' || uploadedFile.type == 'video/quicktime')
            {
                let base64 = await self.readUploadedFileAsBase64Str(this);
                self.$store.commit('setExtraVideoFile', { video: base64, type: uploadedFile.type });
                self.addQrCode();
                self.uploading = false;
                self.invalidFile = false;
                self.fileSizeTooBig = false;
            } else {
                var objectUrl = self.createObjectURL(uploadedFile);
                var duration = await self.getAudioDuration(objectUrl);

                let soundFile = {
                    url: objectUrl,
                    duration: duration,
                    isUpload: true
                };
                self.$store.commit('setExtraSoundFile', soundFile);
                self.uploading = false;
                self.invalidFile = false;
                self.fileSizeTooBig = false;
            }
        });
    },
    methods: {
        beforeRecording() {
            this.addQrCode();
        },
        afterRecording(recording) {
            // add to store
            this.$store.commit('setExtraSoundFile', recording);
        },

        removeExtraRecord() {
            this.$store.commit('setExtraSoundFile', null);
            this.$store.commit('setExtraVideoFile', null);
            this.addQrCode(false);
        },

        uploadVideo() {
            this.$refs.videoUpload.click();
        },

        micFailed() {
            alert('Ihr Mikrofon kann leider nicht aktiviert werden. Bitte heben Sie die Blockierung des Mikrofons in Ihrem Browser auf und versuchen es erneut!');
            this.isRecording = false;
            this.isCountdown = false;
            this.initUserMedia = false;
        },

        addQrCode(add = true) {
            this.$store.commit('updateField', {
                path: 'extraSound.use',
                value: add
            });
        },

        async readUploadedFileAsBase64Str(input) {
            return new Promise((resolve, reject) => {

                if (input.files && input.files[0]) {
                    var reader = new FileReader();

                    reader.onload = function(e) {
                        resolve(e.target.result);
                    }

                    reader.readAsDataURL(input.files[0]); // convert to base64 string
                }
            });
        },

        /**
         * Convert a File into an object url
         * @param file File
         */
        createObjectURL(file) {
            if ( window.webkitURL ) {
                return window.webkitURL.createObjectURL( file );
            } else if ( window.URL && window.URL.createObjectURL ) {
                return window.URL.createObjectURL( file );
            } else {
                return null;
            }
        },

        async getAudioDuration(file) {
            return new Promise((resolve, reject) => {
                var audioElement = new Audio();

                audioElement.addEventListener('canplaythrough', function(e) {
                    let seconds = e.currentTarget.duration
                    var date = new Date(seconds * 1000); // multiply by 1000 because Date() requires milliseconds
                    var time = date.toTimeString().split(' ')[0].split(':');
                    // remove hour (which can be off anyway, depending on the timezone)
                    // ..and just keep minutes and seconds
                    time.splice(0, 1);
                    resolve(time.join(':'));
                });
                audioElement.src = file;
            });
        },

        togglePlayback() {
            const player = this.$refs.player;
            if (player) {
                player.playback();
            }
        }
    }
};
</script>
